import { render, staticRenderFns } from "./ExchangeLog.vue?vue&type=template&id=46a5769e"
import script from "./ExchangeLog.vue?vue&type=script&lang=js"
export * from "./ExchangeLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports